/** The references object of all modules needed for components initialization */
var references = {
    'search' : require('_core_ext/pages/search'),
    'brands': require('_core_ext/pages/search/brands'),
    'refinements' : require('_core_ext/pages/search/refinements'),
};

module.exports = {
    'references' : references
};
